import { Pegasus } from 'corso-types';

const unfulfilled = [
  {
    fact: Pegasus.Fact.orderFulfillmentDisplayStatus,
    operator: Pegasus.Operator.in,
    value: ['unfulfilled'],
  },
] as const satisfies Pegasus.Expression[];

const notCanceled = [
  {
    fact: Pegasus.Fact.orderCanceled,
    operator: Pegasus.Operator.equal,
    value: false,
  },
] as const satisfies Pegasus.Expression[];

const paid = [
  {
    fact: Pegasus.Fact.orderFinancialStatus,
    operator: Pegasus.Operator.in,
    value: ['paid', 'partially_refunded'],
  },
] as const satisfies Pegasus.Expression[];

export const requiredConditionsByEditType = {
  [Pegasus.OrderEditType.CANCEL_ORDER]: [
    ...unfulfilled,
    ...notCanceled,
    ...paid,
  ],
  [Pegasus.OrderEditType.REMOVE_PACKAGE_PROTECTION]: [...notCanceled, ...paid],
  [Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS]: [...unfulfilled],
  [Pegasus.OrderEditType.MODIFY_QUANTITY]: [...unfulfilled, ...paid],
  [Pegasus.OrderEditType.UPDATE_EMAIL]: [...notCanceled],
  [Pegasus.OrderEditType.UPDATE_SHIPPING_LINE]: [...unfulfilled, ...paid],
  [Pegasus.OrderEditType.ADD_DISCOUNT_CODE]: [...notCanceled, ...paid],
} satisfies Record<Pegasus.OrderEditType, Pegasus.Expression[]>;
